import React from 'react';
import InfluencerPasswordFormComponent from '../../components/AuthForms/InfluencerPasswordFormComponent';
// import { BrandSignInFormComponent } from '../../components/AuthForms/BrandSignInFormComponent'

export const SigninInfluencerResetPasswordPage = () => {
  return (
    <div className="signup_wrapper">
      <div className="container-fluid vh-100 px-0">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6 px-0">
            <div className="signup_wrapper_poster">
              <img src="/images/common/flynt-brand-posters.jpg"
                alt="Signin Poster" />
            </div>
          </div>
          <div className="col-md-6">
            {/* <div className="max-w-360 mx-auto"> */}
            <div className="max-w-360 mx-auto signup_wrapper_formarea">
              <div className="signup_wrapper_content">

                <h5 className="text-left"><strong>Reset Password</strong></h5>
                <p>To reset your Brand/Agency password please enter email ID you used while registration.
                   We will sent you send you inctructions to reset your password</p>
              </div>
              {/* <BrandSignInFormComponent/> */}
              <InfluencerPasswordFormComponent/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
